import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $parent_project_activity_budget_id: Int!, $data: [ProjectActivityBudgetInput]!){
  upsertProjectBudgetBreakdowns(project_id: $project_id, parent_project_activity_budget_id: $parent_project_activity_budget_id,  data: $data){
    ${projectFragment}
  }
}`